var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { TwitterShareButton, TwitterIcon } from 'react-share';
import { Dialog, Paper, MenuList, MenuItem, ListItemIcon, ListItemText, TextField, Typography } from '@material-ui/core';
import SvgLink from '@material-ui/icons/Link';
var styles = function (theme) {
    var _a;
    return ({
        image: {
            verticalAlign: 'top',
            maxWidth: '100%',
            minWidth: '100%',
            width: '100%'
        },
        clipboard: {
            fontSize: '18px',
            textAlign: 'center',
            marginTop: '10px',
            color: '#1e882d',
            fontWeight: 400
        },
        networkShare: {
            width: '100%',
            height: '100%'
        },
        fullPageXs: (_a = {},
            _a[theme.breakpoints.down('xs')] = {
                width: '100%',
                height: '100%',
                margin: 0,
                overflowY: 'auto'
            },
            _a),
        shareLinkPaper: {
            minHeight: 80,
            padding: 10,
            minWidth: 460
        }
    });
};
/**
 * Create component class
 */
var ShareDialogComponent = /** @class */ (function (_super) {
    __extends(ShareDialogComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function ShareDialogComponent(props) {
        var _this = _super.call(this, props) || this;
        // Defaul state
        _this.state = {};
        return _this;
        // Binding functions to `this`
    }
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    ShareDialogComponent.prototype.render = function () {
        var _a = this.props, classes = _a.classes, translate = _a.translate, shareOpen = _a.shareOpen, onClose = _a.onClose, openCopyLink = _a.openCopyLink, post = _a.post, onCopyLink = _a.onCopyLink;
        return (React.createElement(Dialog, { className: classes.fullPageXs, title: 'Share On', open: shareOpen, onClose: onClose },
            React.createElement(Paper, { className: classes.shareLinkPaper }, !openCopyLink
                ? (React.createElement(MenuList, null,
                    React.createElement("div", null,
                        React.createElement(TwitterShareButton, { onShareWindowClose: onClose, url: location.origin + "/" + post.get('ownerUserId') + "/posts/" + post.get('id'), quote: post.get('body'), hashtag: "#" + post.getIn(['tags', 0], '') },
                            React.createElement(MenuItem, null,
                                React.createElement(ListItemIcon, { classes: { root: classes.networkShare } },
                                    React.createElement(TwitterIcon, { size: 32, round: true })),
                                React.createElement(ListItemText, { inset: true, primary: 'twitter' })))),
                    React.createElement(MenuItem, { onClick: onCopyLink },
                        React.createElement(ListItemIcon, null,
                            React.createElement(SvgLink, null)),
                        React.createElement(ListItemText, { inset: true, primary: 'post.copyLinkButton' }))))
                : React.createElement("div", null,
                    React.createElement(TextField, { autoFocus: true, fullWidth: true, id: 'text-field-default', defaultValue: location.origin + "/" + post.get('ownerUserId') + "/posts/" + post.get('id') }),
                    React.createElement(Typography, { className: classNames('animate-top', classes.clipboard), 
                        // variant='headline'
                        component: 'h2' }, "Link has been copied to clipboard ...")))));
    };
    return ShareDialogComponent;
}(Component));
export { ShareDialogComponent };
/**
 * Map dispatch to props
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {};
};
/**
 * Map state to props
 */
var mapStateToProps = function (state, ownProps) {
    return {
    // translate: getTranslate(state.get('locale'))
    };
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ShareDialogComponent));



//////////////////
// WEBPACK FOOTER
// ./src/components/shareDialog/ShareDialogComponent.tsx
// module id = 1178
// module chunks = 0 1 2 3 4 5 6 7